<tec-modal
	[isVisible]="true"
	[title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.TITLE' | translate"
    [buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
	(closeEvent)="closeModal($event)">
	<ng-container body [formGroup]="form">
        <!-- TABS -->
        <tec-tabs [tabs]="tabs" type="pills" />

        <!-- FOTOCOPIA -->
        <div *ngIf="tabs?.length && tabs[0]?.selected" class="grid" style="gap: 16px" formGroupName="photocopy_check">
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="blocking_step" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="ip_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="identifier_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
                [tagImage]="{icon: 'icon-mail', status: 'notice'}">
                <tec-list-detail>
                    <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL_DESCRIPTION' | translate }}</span>
                </tec-list-detail>
                <tec-switch formControlName="email_alert_available" size="sm"></tec-switch>
                @if (form.get('photocopy_check.email_alert_available')?.value) {
                    <div subheader style="padding: 12px;">
                        <tec-form-group [errorMsg]="reactiveFormService.hasMsgError(form.get('photocopy_check.email_alert'))">
                            <tec-textarea formControlName="email_alert"
                                placeholder="email@emaill.com, email@mail.com,"
                                [hasError]="reactiveFormService.hasError(form.get('photocopy_check.email_alert'))"
                            ></tec-textarea>
                        </tec-form-group>
                    </div>
                }
            </tec-item>
        </div>

        <!-- FOTO -->
        <div *ngIf="tabs?.length && tabs[1]?.selected" class="grid" style="gap: 16px" formGroupName="screen_photo">
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="blocking_step" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="ip_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="identifier_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
                [tagImage]="{icon: 'icon-mail', status: 'notice'}">
                <tec-list-detail>
                    <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL_DESCRIPTION' | translate }}</span>
                </tec-list-detail>
                <tec-switch formControlName="email_alert_available" size="sm"></tec-switch>
                @if (form.get('screen_photo.email_alert_available')?.value) {
                    <div subheader style="padding: 12px;">
                        <tec-form-group [errorMsg]="reactiveFormService.hasMsgError(form.get('screen_photo.email_alert'))">
                            <tec-textarea formControlName="email_alert"
                                placeholder="email@emaill.com, email@mail.com,"
                                [hasError]="reactiveFormService.hasError(form.get('screen_photo.email_alert'))"
                            ></tec-textarea>
                        </tec-form-group>
                    </div>
                }
            </tec-item>
        </div>

        <!-- IMAGEN MANIPULADA -->
        <div *ngIf="tabs?.length && tabs[2]?.selected" class="grid" style="gap: 16px" formGroupName="manipulated_photo">
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="blocking_step" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="ip_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="identifier_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
                [tagImage]="{icon: 'icon-mail', status: 'notice'}">
                <tec-list-detail>
                    <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL_DESCRIPTION' | translate }}</span>
                </tec-list-detail>
                <tec-switch formControlName="email_alert_available" size="sm"></tec-switch>
                @if (form.get('manipulated_photo.email_alert_available')?.value) {
                    <div subheader style="padding: 12px;">
                        <tec-form-group [errorMsg]="reactiveFormService.hasMsgError(form.get('manipulated_photo.email_alert'))">
                            <tec-textarea formControlName="email_alert"
                                placeholder="email@emaill.com, email@mail.com,"
                                [hasError]="reactiveFormService.hasError(form.get('manipulated_photo.email_alert'))"
                            ></tec-textarea>
                        </tec-form-group>
                    </div>
                }
            </tec-item>
        </div>

        <!-- IDENTIFICADOR BLOQUEADO -->
        <div *ngIf="tabs?.length && tabs[3]?.selected" class="grid" style="gap: 16px" formGroupName="identifier_blocked">
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.FINISH_PROCESS' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="blocking_step" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_IP' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="ip_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.BLOCK_ID' | translate"
                [tagImage]="{icon: 'icon-x-circle', status: 'notice'}">
                <tec-switch formControlName="identifier_block" size="sm"></tec-switch>
            </tec-item>
            <tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL' | translate"
                [tagImage]="{icon: 'icon-mail', status: 'notice'}">
                <tec-list-detail>
                    <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_OCR_FRAUD_SCORING.NOTIFY_EMAIL_DESCRIPTION' | translate }}</span>
                </tec-list-detail>
                <tec-switch formControlName="email_alert_available" size="sm"></tec-switch>
                @if (form.get('identifier_blocked.email_alert_available')?.value) {
                    <div subheader style="padding: 12px;">
                        <tec-form-group [errorMsg]="reactiveFormService.hasMsgError(form.get('identifier_blocked.email_alert'))">
                            <tec-textarea formControlName="email_alert"
                                placeholder="email@emaill.com, email@mail.com,"
                                [hasError]="reactiveFormService.hasError(form.get('identifier_blocked.email_alert'))"
                            ></tec-textarea>
                        </tec-form-group>
                    </div>
                }
            </tec-item>
        </div>
	</ng-container>
</tec-modal>